import { render, staticRenderFns } from "./CargoListTemplates.vue?vue&type=template&id=3bcd8735&scoped=true&"
import script from "./CargoListTemplates.vue?vue&type=script&lang=js&"
export * from "./CargoListTemplates.vue?vue&type=script&lang=js&"
import style0 from "./CargoListTemplates.vue?vue&type=style&index=0&id=3bcd8735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd8735",
  null
  
)

export default component.exports